import usLaunchImg from '../images/us-launch.jpg';

/**
 * US launch banner (Figma `997:35804`, 1920 × 1281).
 *
 * Full-bleed warm-interior image with a light dark overlay and a white
 * statement. Replaces the previous `HomePageUsLaunchStory` treatment. Landscape
 * (`aspect-[1920/1281]`) on desktop, portrait (`aspect-[768/1178]`) on mobile.
 */
export const UsLaunchBannerSection = () => {
    return (
        <section className="relative w-full overflow-hidden bg-black max-md:aspect-[768/1178] md:aspect-[1920/1281]">
            <img
                src={usLaunchImg}
                alt=""
                aria-hidden="true"
                className="absolute inset-0 size-full max-w-none object-cover object-bottom"
                loading="lazy"
            />
            <div className="absolute inset-0 bg-black/10" />
            {/* Fade the bottom edge into black so the banner blends into the
                black Discover Projects section below (no hard seam line). */}
            <div
                aria-hidden="true"
                className="pointer-events-none absolute inset-x-0 bottom-0 bg-linear-to-b from-transparent to-black max-md:h-1/4 md:h-1/3"
            />

            {/* Centred statement — portrait crop on mobile, landscape on desktop */}
            <p className="absolute inset-x-0 m-0 text-center font-sans font-normal leading-[1.07] text-white max-md:top-[40%] max-md:px-[3.6%] max-md:text-[5.47vw] max-md:tracking-[-0.263vw] md:top-[45%] md:text-[4.167vw] md:tracking-[-0.2vw]">
                Built in New Zealand. Proven in Australia,
                <br />
                coming to America.
            </p>
        </section>
    );
};
